module.exports = __webpack_public_path__ + "img/avakjan.d0ac5f7e.jpg";